
import React, { useEffect, useState } from 'react';
import styles from './add_update_invoice.module.css';
import { ActionButton, Flex, Item, TabList, TabPanels, Tabs, ToastQueue, View } from '@adobe/react-spectrum';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { useTranslation } from 'react-i18next';
import AddInvoiceDetail from './formSections/InvoiceDetailSection';
import AddSupplierDetail from './formSections/InvoiceSupplierSection';
import AddBankInfo from './formSections/InvoiceBankSection';
import InvoiceShippingSection from './formSections/InvoiceShippingSection';
import InvoiceFinanceSection from './formSections/InvoiceFinanceSection';
import InvoiceCustomAttributesSection from './formSections/InvoiceCustomAttributes';
import InvoiceCommentSection from './formSections/InvoiceCommentSection';
import InvoiceCustomerSection from './formSections/InvoiceCustomerSection';
import { Invoice } from '../../../../services/soap/dataObjects/Invoice';
import InvoiceTransactionComponent from './formSections/InvoiceITransactionSection';
import { ChevronLeft } from 'react-bootstrap-icons';
import { ActivityIconBlue } from '../../../../components/protected/Icons/IconsLib';
import { Button } from 'react-bootstrap';
interface IAddUpdateInvoiceProps {
    selectedInvoice: any;
    isEdit?: boolean;
    handleBackClick?: () => void;
    invoiceType?: any
}
const AddUpdateInvoice: React.FC<IAddUpdateInvoiceProps> = ({
    selectedInvoice, isEdit, handleBackClick, invoiceType
}) => {
    const { store, itemService } = useDependency();
    let [invoice, setInvoice] = useState<any>();
    const { t } = useTranslation('invoice');
    const _t = (key: string) => t(`add_update_invoice.${key}`, { ns: 'invoice' });
    const _tt = (key: string) => t(`invoice_common.${key}`, { ns: 'invoice' });

    useEffect(() => {
        if (isEdit && selectedInvoice) {
            setInvoice(selectedInvoice);
        }
        else {
            setInvoice({} as Invoice);
        }
    }, [selectedInvoice, isEdit]);

    return (
        <Flex width="100%" direction={'column'}>
            <Flex width="100%" direction={'column'} UNSAFE_style={{ padding: '10px' }}>
                <View UNSAFE_className={styles.header_main}>
                    <View UNSAFE_className={styles.header_child}>
                        <View UNSAFE_className={styles.frame_parent}>
                            <View UNSAFE_className={styles.icon_activity_parent}>
                                {handleBackClick &&
                                    <ActionButton isQuiet onPress={handleBackClick} UNSAFE_className={styles.back_button}>
                                        <ChevronLeft size={20} />
                                    </ActionButton>
                                }
                                <b className={styles.activity_name}>
                                    {_t(isEdit ? 'edit_invoice' : 'add_invoice')}
                                </b>
                            </View>
                        </View>
                    </View>
                </View>
            </Flex>
            <View width={'100%'} UNSAFE_style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                <Flex direction={'row'} gap={'size-100'}>
                    <AddInvoiceDetail isEdit={false} invoice={invoice} onChange={setInvoice} />
                </Flex>
                <Flex direction={'row'} gap={'size-100'}>
                    <AddSupplierDetail invoice={invoice} isEdit={false} onChange={setInvoice} />
                    <AddBankInfo invoice={invoice} isEdit={false} onChange={setInvoice} />
                </Flex>
                <Flex direction={'row'} gap={'size-100'}>
                    <InvoiceCustomerSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                    <InvoiceShippingSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                </Flex>
                <Flex direction={'row'} gap={'size-100'}>
                    <InvoiceFinanceSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                    <InvoiceCustomAttributesSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                </Flex>
                <Flex>
                    <InvoiceCommentSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                </Flex>
                <Flex gap={'size-100'} marginTop={'size-100'} width={'100%'}>
                    <InvoiceTransactionComponent invoice={invoice} isEdit={false} onInvoiceChange={setInvoice} />
                </Flex>
            </View>
            <Flex
                UNSAFE_style={{
                    backgroundColor: "#FFF",
                    justifyContent: "end",
                    width: "100%",
                    padding: "0.6rem",
                    paddingRight: 10,
                    // boxShadow: "0 -1px 1px rgba(0,0,0,0.1)",
                    borderTop: "2px solid var(--neutral-10, #ECEFF1)",
                    position: "sticky",
                    bottom: 0,
                    marginTop: "70px",
                    zIndex: 1,
                }}
            >
                <Flex gap={"size-200"} UNSAFE_className={styles.button_container}>
                    <Button
                        variant="danger"
                        onClick={() => handleBackClick && handleBackClick()}
                        className={`${styles.btn} ${styles.btn_cancel}`}
                    >
                        {_tt("button_cancel")}
                    </Button>
                    <Button
                        type="submit"
                        onClick={() => { }}
                        className={`${styles.btn} ${styles.btn_add}`}
                    >
                        {_tt("button_save")}
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default AddUpdateInvoice;
